import { define } from 'wicked-elements'
import Flickity from 'flickity'
import 'flickity/dist/flickity.min.css'

define('[data-component~="slideshow"]', {
  init () {
    this.$slider = this.element.querySelector('[data-slider]')
    this.$caption = this.element.querySelector('[data-caption-container]')
    this.$next = this.element.querySelector('[data-next]')
    this.$prev = this.element.querySelector('[data-prev]')
    this.$supplemental = this.element.querySelector('[data-supplemental-ui]')
    this.count = this.$slider.children.length
    this.speed = parseInt(this.element.getAttribute('data-speed'))
    this.loadImage = this.loadImage.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleNext = this.handleNext.bind(this)
    this.handlePrev = this.handlePrev.bind(this)
    this.handlePause = this.handlePause.bind(this)
    this.handleResume = this.handleResume.bind(this)
  },
  initFlickity () {
    this.flkty = new Flickity(this.$slider, {
      pageDots: false,
      prevNextButtons: false,
      // arrowShape: 'M10.3,52.7l35.6,35.5L42,92L0,50L42,8l3.9,3.8L10.3,47.3H100v5.4H10.3z',
      adaptiveHeight: true,
      wrapAround: true,
      autoPlay: this.speed
    })

    this.flkty.on('change', this.handleChange)
    this.flkty.on('select', this.loadImage)
    setTimeout(this.loadImage)

    if (this.$next) this.$next.addEventListener('click', this.handleNext)
    if (this.$prev) this.$prev.addEventListener('click', this.handlePrev)
    if (this.$supplemental) {
      this.$supplemental.addEventListener('mouseenter', this.handlePause)
      this.$supplemental.addEventListener('mouseleave', this.handleResume)
    }
  },
  loadImage () {
    const selected = this.flkty.selectedElement
    const img = selected.querySelector('img')
    if (img) img.dispatchEvent(new CustomEvent('triggerLoad'))
  },
  handleChange () {
    const selected = this.flkty.selectedElement
    if (this.$caption) this.$caption.innerHTML = selected.dataset.caption || ''  
  },
  handleNext () {
    this.flkty.next()
  },
  handlePrev () {
    this.flkty.previous()
  },
  handlePause () {
    this.flkty.pausePlayer()
  },
  handleResume () {
    this.flkty.unpausePlayer()
  },
  connected () {
    if (this.count > 1) {
      this.initFlickity()
    }
  },
  disconnected () {
    if (this.flkty) {
      this.flkty.destroy()
      if (this.$next) this.$next.removeEventListener('click', this.handleNext)
      if (this.$prev) this.$prev.removeEventListener('click', this.handlePrev)
      if (this.$supplemental) {
        this.$supplemental.removeEventListener('mouseenter', this.handlePause)
        this.$supplemental.removeEventListener('mouseleave', this.handleResume)
      }
    }
  }
})